import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import CalendarPage from "./CalendarPage";
import ReservationsPage from "./ReservationsPage";
import MapView from "./MapView";
import HomePage from "./HomePage";
import PricingPage from "./PricingPage";
import FinancePage from "./FinancePage";
import ApartmentsPage from "./ApartmentsPage";
import React from "react";




export default function App() {

  const [authenticated, setAuthenticated] = React.useState(false);
  const [password, setPassword] = React.useState("");


  if (!authenticated) {
  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "100vh",
      fontFamily: "sans-serif"
    }}>
      <h2>Parking Manager</h2>
      <input
        type="password"
        placeholder="Enter password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        style={{ padding: "10px", marginBottom: "10px" }}
      />
      <button
        style={{ padding: "10px 20px", cursor: "pointer" }}
        onClick={() => {
          if (password === "HaveFun12!") { // <<< change to your password
            setAuthenticated(true);
          } else {
            alert("Wrong password");
          }
        }}
      >
        Login
      </button>
    </div>
  );
}


  return (
    <Router>
      <div style={{ padding: 20, fontFamily: "sans-serif" }}>
        <nav
  className="navbar"
  style={{
    overflowX: "auto",
    whiteSpace: "nowrap",
    padding: "12px 20px",
    backgroundColor: "#222",
    borderRadius: "8px",
    marginBottom: 30,
    display: "flex",
    alignItems: "center",
    gap: "10px",
  }}
>
  <img
    src="/foto.png"
    alt="Logo"
    style={{
      height: "40px",
      minWidth: "40px",
      borderRadius: "4px",
    }}
  />

  {[ 
    { to: "/", label: "Dashboard" },
    { to: "/calendar", label: "Calendar" },
    { to: "/reservations", label: "All Reservations" },
    { to: "/map", label: "Map" },
    { to: "/pricing", label: "Pricing" },
    { to: "/finance", label: "Finance" },
    { to: "/apartments", label: "Apartments" },

  ].map((item) => (
    <Link
      key={item.to}
      to={item.to}
      style={{
        color: "white",
        textDecoration: "none",
        fontWeight: "bold",
        padding: "8px 16px",
        borderRadius: "6px",
        backgroundColor: "#444",
        transition: "background 0.3s",
        display: "inline-block",
      }}
      onMouseOver={(e) => (e.target.style.backgroundColor = "#666")}
      onMouseOut={(e) => (e.target.style.backgroundColor = "#444")}
    >
      {item.label}
    </Link>
  ))}
</nav>


        <Routes>
<Route path="/" element={<HomePage />} />
<Route path="/calendar" element={<CalendarPage />} />
<Route path="/reservations" element={<ReservationsPage />} />
<Route path="/map" element={<MapView />} />
<Route path="/pricing" element={<PricingPage />} />
<Route path="/finance" element={<FinancePage />} />
<Route path="/apartments" element={<ApartmentsPage />} />




</Routes>

      </div>
    </Router>
  );
}
